<template>
  <router-view />
</template>

<script>
export default {
  name: 'ClimbingIndex'
}
</script>
